"use client";

import { useState } from "react";
import { detectOS, type PlatformEnvironment, type PlatformOS } from "./platform";

export type { PlatformOS };

interface CapacitorGlobal {
  Capacitor?: {
    getPlatform?: () => string;
  };
}

function readEnvironment(): PlatformEnvironment | null {
  if (typeof window === "undefined") return null;
  return {
    capacitorPlatform: (window as CapacitorGlobal).Capacitor?.getPlatform?.(),
    maxTouchPoints: window.navigator.maxTouchPoints,
    userAgent: window.navigator.userAgent,
  };
}

/**
 * The operating system the app is running on, for platform-adaptive UI
 * (e.g. iOS card sheets vs Material bottom sheets).
 *
 * Returns "other" during SSR; the OS never changes within a session.
 */
export const usePlatform = (): PlatformOS => {
  const [os] = useState(() => detectOS(readEnvironment()));
  return os;
};
